"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
var colors = {
    BLACK: '#000000',
    BLACK_70: 'rgba(0,0,0, .7)',
    TRANSPARENT: 'transparent',
    WHITE: '#FFFFFF',
    GREY_50: '#fbfbfb',
    GREY_100: '#f8f8f8',
    GREY_150: '#f6f6f6',
    GREY_175: '#eeeeee',
    GREY_200: '#ededed',
    GREY_250: '#dedede',
    GREY_300: '#cfcfcf',
    GREY_350: '#bcbcbc',
    GREY_400: '#aaaaaa',
    GREY_450: '#929292',
    GREY_500: '#808080',
    GREY_550: '#717171',
    GREY_650: '#505050',
    ORANGE_300: '#ec4e20',
    BLUE_LIGHT_200: '#f1fbff',
    BLUE_LIGHT_300: '#e3f7ff',
    BLUE_300: '#007def',
    BLUE_400: '#0069d6',
    BLUE_500: '#0060c4',
    BLUE_600: '#0059b5',
    BLUE_MEDIUM_300: '#0054A1',
    BLUE_MEDIUM_400: '#004889',
    BLUE_MEDIUM_500: '#003268',
    BLUE_DEEP_300: '#001d49',
    BLUE_DEEP_400: '#001a35',
    GREEN_500: '#0fc70f',
    GREEN_600: '#12ae12',
    GREEN_700: '#159414',
    ROSE_50: '#ffebec',
    RED_100: '#f6c5c6',
    RED_300: '#da171a',
    SALMON: '#ee4c51',
    CORAL: '#d0454a',
    BRICK: '#b13e42',
    GRAPE: '#a8228e',
    YELLOW_500: '#ffae00',
    MOJITO: '#00a7a3',
    ORCHID: '#6400ed',
    ALIEN: '#0fc70f',
};
exports.colors = colors;
//# sourceMappingURL=colors.js.map